import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { clientApi } from "./clientApi";
import authSlice from "./authSlice";
import settingsReducer from "./settingsSlice";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import helperSlice from "./helperSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  settings: settingsReducer,
  helper: helperSlice,
  [clientApi.reducerPath]: clientApi.reducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "settings"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(clientApi.middleware),
});

// Create Persistor
export const persistor = persistStore(store);
